<template>
  <Card :btnMsg="$t('paypalForm.btn_text')" @changeStep="changeStep">
    <div class="card-paypalForm">
      <div class="card-content">
        <div class="card-header">
          <div class="card-title-box">
            <div class="card-title" v-html="$t('paypalForm.title')"></div>
            <div class="card-text">{{ $t('paypalForm.text') }}</div>
          </div>
          <img :src="writerPic" />
        </div>
        <a-form-model ref="paypalForm" :model="paypalFormData" :rules="formRules">
          <div class="code-box">
            <a-form-model-item :label="$t('paypalForm.form_paypal')" prop="account">
              <a-input :placeholder="$t('paypalForm.form_paypal_placeholder')" v-model="paypalFormData.account" size="large" type="primary"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('paypalForm.form_ensure_paypal')" prop="confirm_account">
              <a-input
                :placeholder="$t('paypalForm.form_ensure_paypal_placeholder')"
                v-model="paypalFormData.confirm_account"
                size="large"
                type="primary"
              ></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('paypalForm.form_paypal_name')" prop="name">
              <a-input
                :placeholder="$t('paypalForm.form_paypal_name_placeholder')"
                v-model="paypalFormData.name"
                size="large"
                type="primary"
              ></a-input>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import { postSubmit } from '@/api/portal';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      paypalFormData: {},
      writerPic: require('@/assets/writer.png'),
      formRules: {
        account: [{ required: true, message: this.$t('paypalForm.form_paypal_placeholder'), trigger: 'blur' }],
        confirm_account: [
          { required: true, message: this.$t('paypalForm.form_ensure_paypal_placeholder'), trigger: 'blur' },
          { validator: this.checkPaypal, trigger: 'change' },
        ],
        name: [{ required: true, message: this.$t('paypalForm.form_paypal_name_placeholder'), trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    checkForm() {
      let bol = false;
      this.$refs.paypalForm.validate(valid => {
        if (valid) {
          bol = true;
          return true;
        } else {
          bol = false;
          return false;
        }
      });
      return bol;
    },
    checkPaypal(rule, value, callback) {
      if (this.paypalFormData.account !== this.paypalFormData.confirm_account) {
        callback(new Error(this.$t('inputNotSame')));
      }
      callback();
    },
    changeStep() {
      let bol = this.checkForm();
      if (bol) {
        this.$emit('input', { ...this.form, paypal: this.paypalFormData });
        postSubmit({ ...this.form, paypal: this.paypalFormData }).then(res => {
          this.$parent.changeStep('thanksAll',this.form);
        });
      }
    },
  },
};
</script>

<style lang="scss">
.card-paypalForm {
  position: relative;
  width: 100%;
  .card-header {
    display: flex;
    gap: 12px;
    img {
      width: 154px;
      height: 154px;
      margin-top: -24px;
      margin-right: -24px;
    }
  }
  .card-title-box {
    width: 60%;
  }
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    word-wrap: break-word;
    margin-bottom: 20px;
  }
  .order-why-box {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .order-why {
      font-size: 14px;
      font-weight: 400;
      color: #676767;
    }
    .order-answer {
      font-size: 16px;
      font-weight: 500;
      color: #1a1a1a;
    }
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
